import styled from 'styled-components'

export {
  GroupContainer,
  SectionDivider,
  SubTabsSection,
  TypeContent,
  TypeSection,
} from '@/configuration/pages/ConfigurationPage/sharedStyles'

export const ColorsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${props => props.theme.spacing.sp16};
`
